module.exports = __webpack_public_path__ + "img/2-8506.aba8936a.png";